/**
 * @ngdoc service
 * @name mwSnackbarService
 * @module mw.components.snackbar
 *
 * @description
 * A service used to open snackbars,
 * the service expects you to pass it a string or html in which is will procces
 */

/**
 * @ngdoc method
 * @name mwSnackbarService#open
 * @param {string|object} [config] - String of content (can be HTML) that will be displayed in the snackbar OR snackbar panel config override
 *
 *
 * @returns promise that resolves with a reference to the $mdPanelRef
 */

export class SnackbarService {
    stack = [];
    lastMsg = null;
    debounce = null;
    cooldown = 50;
    currentPanelRef = null;
    autoCloseTimeout = null;

    constructor(private $window, private $mdPanel, private $q, private $timeout) {
        'ngInject';
    }

    open(snackbarConfig: string | ng.material.IPanelConfig = {}) {
        const attachToDefaultSelector = '.mw-app-container__main';
        const attachToElement = document.querySelector(attachToDefaultSelector);
        let panelPosition = this.$mdPanel.newPanelPosition()
            .absolute()
            .bottom('-100px')
            .left('0');

        let panelAnimation = this.$mdPanel.newPanelAnimation();
        panelAnimation.duration(200);
        panelAnimation.withAnimation({
            open: 'mw-snackbar__animation-open',
            close: 'mw-snackbar__animation-close'
        });

        return this.$q((resolve, reject) => {
            let panelConfig = Object.assign({
                    attachTo: angular.element(attachToElement),
                    controllerAs: '$ctrl',
                    controller: class SnackbarPanel {
                        constructor(private mdPanelRef) {
                            'ngInject';
                        }

                        close() {
                            this.mdPanelRef.close();
                        }
                    },
                    template: `
                        <mw-snackbar on-close="$ctrl.close()">
                            {{$ctrl.text}}
                        </mw-snackbar>
                    `,
                    locals: {
                        text: snackbarConfig
                    },
                    panelClass: 'mw-snackbar__panel',
                    focusOnOpen: false,
                    propagateContainerEvents: true,
                    groupName: 'mwSnackbarsGroup',
                    position: panelPosition,
                    animation: panelAnimation,
                    onDomAdded: (panelRef) => {
                        this.currentPanelRef = panelRef;
                    },
                    onDomRemoved: (panelRef) => {
                        if (this.autoCloseTimeout) {
                            this.$timeout.cancel(this.autoCloseTimeout);
                        }
                        this.stack.shift();
                        this.showStacked();
                        resolve(panelRef);
                    }
                },
                (typeof snackbarConfig === 'object') ? snackbarConfig : {}
            );

            this.internalShow(panelConfig, resolve, reject);
        });
    }

    close() {
        if (this.autoCloseTimeout) {
            this.$timeout.cancel(this.autoCloseTimeout);
        }

        if (this.currentPanelRef && this.currentPanelRef[1]) {
            this.currentPanelRef[1].close();
        }
    }

    internalShow(panelConfig, resolve, reject) {
        (() => {
            if (this.lastMsg === panelConfig.locals.text) {
                this.$timeout.cancel(this.debounce);
            }
            this.lastMsg = panelConfig.textContent;
            this.debounce = this.$timeout(() => {
                this.lastMsg = null;
                this.stack.push([panelConfig, resolve, reject]);
                if (this.stack.length === 1) {
                    this.showStacked();
                }
            }, this.cooldown);
        })();
    }

    showStacked() {
        if (!this.stack.length) {
            return;
        }
        const [panelConfig, resolve, reject] = this.stack[0];
        this.$mdPanel.open(panelConfig).then(() => {
            this.autoCloseTimeout = this.$timeout(() => {
                this.close();
            }, (typeof panelConfig === 'object' && panelConfig.timeout) || 3000);
        }, reject);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/snackbar/snackbar.service.ts